import {create} from 'zustand';
import {persist} from 'zustand/middleware';

const usePersistentAuthStore = create(
  persist(
    set => ({
      auth: null,

      setAuth: auth => {
        set(() => ({
          auth: auth,
        }));
      },

      clearAuth: () => {
        set(() => ({
          auth: null,
        }));
      },

      updateAuthKey: (key, value) => {
        set(state => ({
          auth: {
            ...state.auth,
            [key]: value,
          },
        }));
      },
    }),
    {
      name: 'auth-storage',
      version: 1,
    }
  )
);

export default usePersistentAuthStore;
